import { useState, useEffect } from "react";

function Counter({ end, duration = 2000, suffix = "+" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [end, duration]);

  return <span>{count}{suffix}</span>;
}

export default function Stats() {
  return (
    <section id="stats" className="stats" style={{ background: "#0070f3", padding: "50px 0" }}>
      <div className="container" data-aos="fade-up">
        <div className="row gy-4">
          {[
            { icon: "bi-emoji-smile", end: 150, label: "Happy Clients", suffix: "+" },
            { icon: "bi-journal-richtext", end: 200, label: "Projects Completed", suffix: "+" },
            { icon: "bi-headset", end: 16, label: "Service Categories", suffix: "+" },
            { icon: "bi-people", end: 15, label: "Team Members", suffix: "+" },
          ].map((stat, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="stats-item text-center w-100 h-100" style={{ color: "#fff" }}>
                <i className={`bi ${stat.icon}`} style={{ fontSize: "2rem", color: "rgba(255,255,255,0.7)" }} />
                <h2 style={{ color: "#fff", fontSize: "2.5rem", fontWeight: "700" }}>
                  <Counter end={stat.end} />
                </h2>
                <p style={{ color: "rgba(255,255,255,0.85)" }}>{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}